<div class="dna-desvincular">
  <div class="dna-desvincular__header">
    <span class="dna-desvincular__simbolo">
      <i class="fas fa-unlink" aria-hidden="true"></i>
    </span>
  </div>

  <div class="dna-desvincular__body">
    <h3 class="dna-desvincular__titulo">Desvincular de "{{ nomeDna }}"?</h3>
    <p class="dna-desvincular__lede">
      Este SKU deixa de herdar as expectativas da família e passa a não ter DNA — um estado
      legítimo, mas sem expectativa parametrizada o PLM não consegue avaliá-lo.
    </p>

    <p class="dna-desvincular__secao-titulo">O que muda</p>

    <ul class="dna-desvincular__mudancas">
      <li class="dna-desvincular__mudanca">
        <i class="fas fa-chart-line dna-desvincular__icone-neutro" aria-hidden="true"></i>
        <span>
          O produto sai dos indicadores do PLM 3Vs — sem expectativa, não há o que comparar com o
          realizado.
        </span>
      </li>

      <li class="dna-desvincular__mudanca">
        <i class="fas fa-code-branch dna-desvincular__icone-mutacao" aria-hidden="true"></i>
        <span *ngIf="temMutacao; else semMutacao">
          Os valores informados neste SKU ({{ parametrosMutados }}) continuam valendo — o item
          passa a operar apenas com os próprios parâmetros.
        </span>
        <ng-template #semMutacao>
          <span>
            Este SKU não tem parâmetros próprios informados, então ele fica sem nenhuma
            expectativa parametrizada.
          </span>
        </ng-template>
      </li>

      <li class="dna-desvincular__mudanca">
        <i class="fas fa-sitemap dna-desvincular__icone-mutacao" aria-hidden="true"></i>
        <span>O DNA passa a padronizar um SKU a menos. Nenhum outro herdeiro é afetado.</span>
      </li>
    </ul>

    <p class="dna-desvincular__desvio">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      <span>
        Se a intenção é só mudar a expectativa deste produto, use <strong>Trocar de DNA</strong> —
        o SKU continua avaliado durante a mudança.
      </span>
    </p>
  </div>

  <div class="dna-desvincular__footer">
    <button type="button" class="btn btn-light" (click)="fechar.emit()">Cancelar</button>
    <button type="button" class="btn dna-desvincular__confirmar" (click)="confirmar.emit()">
      Desvincular
    </button>
  </div>
</div>
